// LiderLayout — mobile-first, sin sidebar. Header compacto + content full.
//
// Los líderes trabajan en el piso de planta con celular — el sidebar no
// aplica. El header muestra wordmark + nombre del líder + clock + logout.

import type { ReactNode } from 'react';
import { Icon } from '../ui/icon';
import { TouchTargetsProvider } from '../ui/touch-targets';
import { useAuth } from '../../lib/auth';
import { useTheme } from '../../lib/theme/use-theme';

interface LiderLayoutProps {
  /** Contenido extra a la derecha del wordmark (ej. estado del turno). */
  headerExtra?: ReactNode;
  children: ReactNode;
}

export function LiderLayout({ headerExtra, children }: LiderLayoutProps) {
  const { state, signOut } = useAuth();
  const { theme, toggle } = useTheme();
  if (state.kind !== 'signed_in') return null;

  return (
    <div className="flex min-h-screen flex-col bg-surface-base text-fg">
      <header className="flex h-[52px] flex-shrink-0 items-center gap-3 border-b border-border bg-surface-base px-4">
        <span className="font-serif text-lg leading-none tracking-tight text-fg">
          Jidokap<span className="text-dot">.</span>
        </span>
        <div className="flex-1">{headerExtra}</div>
        <button
          type="button"
          onClick={toggle}
          className="inline-flex size-11 items-center justify-center rounded text-fg-secondary"
          aria-label="Cambiar tema"
        >
          {theme === 'light' ? '☀' : '☾'}
        </button>
        <button
          type="button"
          onClick={() => signOut()}
          className="inline-flex size-11 items-center justify-center rounded text-fg-secondary"
          aria-label="Cerrar sesión"
        >
          <Icon name="logout" size={16} />
        </button>
      </header>
      <main className="flex-1 px-4 py-5">
        <TouchTargetsProvider>{children}</TouchTargetsProvider>
      </main>
    </div>
  );
}
